"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    shoppingLists: {
      actions: {
        insert: 'Přidat do košíku',
        rename: 'Přejmenovat'
      },
      shoppingListsDialog: {
        title: 'Moje nákupní seznamy'
      },
      saveShoppingListDialog: {
        title: 'Uložit nákupní seznam pod jménem',
        shoppingListName: {
          label: 'Název seznamu',
          helperText: 'Pojmenujte nákupní seznam. Dle jména jej později identifikujete. Jméno můžete později změniť.',
          helperTextPreview: ''
        }
      },
      shoppingListItemCollapsed: {
        quantity: 'ks'
      }
    }
  }
};
var _default = messages;
exports.default = _default;